export default __webpack_public_path__ + "ec0b6497e49ce58a5a098a1a66192646.jpg";